import {Controller} from '@hotwired/stimulus';
import axios from 'axios';

export default class extends Controller {
    connect() {
        const x = document.querySelectorAll('.btn-showtime.is-ticketing:not(.disabled)');
        const sessions = [];
        for (let i = 0; i < x.length; i++) {
            const id = x[i].getAttribute('data-id')

            sessions.push(id);
        }

        if (sessions.length > 0) {
            axios.post('/session/prices', {
                sessions : sessions
            })
                .then(function (response) {
                    for (const [key, value] of Object.entries(response.data)) {
                        const elm = document.querySelector('.btn-showtime[data-id="' + key + '"]');
                        elm.innerHTML += '<span class="amenity price">' + value + '</span>'
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
}